import paginationicon from "../../assets/dashboard/pagination-lefticon.png";

interface PaginationProps<T> {
    currentPage: number;
    handlePageChange: any;
    totalPages: number;
    paginationLength: any;
    pageSize?: number;
    onPageSizeChange?: (size: number) => void;
}

const PAGE_SIZE_OPTIONS = [8, 50, 100, 200];

const PaginationNew2 = <T extends {}>({
    currentPage,
    handlePageChange,
    totalPages,
    paginationLength,
    pageSize,
    onPageSizeChange,
}: PaginationProps<T>) => {

    const showDropdown =
        onPageSizeChange !== undefined &&
        pageSize !== undefined &&
        (totalPages > 1 || pageSize > 50);
    const showPageNav = !!paginationLength;

    if (!showDropdown && !showPageNav) return null;

    return (
        <>
            {/* Pagination Controls */}
            <div className="flex items-center justify-between w-full pb-3 mq575:pt-4 sededulardashborad-alert_pagination mq575:flex-col mq575:gap-2">
                    {/* Rows per page dropdown */}
                    {showDropdown ? (
                        <div className="flex items-center gap-2 relative action-page-leftcard">
                            <span className="text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">Rows per page</span>
                            <select
                                value={pageSize}
                                onChange={(e) => onPageSizeChange!(Number(e.target.value))}
                                className="text-sm border border-surface-border rounded px-2 py-1 bg-white dark:bg-slate-700 dark:text-white dark:border-gray-600 cursor-pointer focus:outline-none focus:ring-1 focus:ring-surface-primary-surface"
                            >
                                {PAGE_SIZE_OPTIONS.map((opt) => (
                                    <option key={opt} value={opt}>{opt}</option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <div />
                    )}
                    {showPageNav && <div className="pagination-blg-dv">
                        {/* Previous Button */}
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                if (currentPage > 1) handlePageChange(currentPage - 1);
                            }}
                            className={currentPage > 1 ? "cursor-pointer" : "disable_button-blg"}
                        >
                            <span>
                                <img
                                    src={paginationicon}
                                    className="leftpagination-cion"
                                    alt="Previous"
                                />
                            </span>
                        </button>

                        {/* Dynamic Pages */}
                        {(() => {
                            const rangeWithDots = [];
                            const delta = 1; // how many pages before/after currentPage to show
                            let pages = [];

                            if (totalPages <= 5) {
                                // Show all pages if total pages are 5 or less
                                for (let i = 1; i <= totalPages; i++) {
                                    pages.push(i);
                                }
                            } else {
                                pages.push(1);

                                if (currentPage > 3) {
                                    pages.push("...");
                                }

                                let start = Math.max(2, currentPage - delta);
                                let end = Math.min(totalPages - 1, currentPage + delta);

                                for (let i = start; i <= end; i++) {
                                    pages.push(i);
                                }

                                if (currentPage < totalPages - 2) {
                                    pages.push("...");
                                }

                                pages.push(totalPages);
                            }

                            return pages.map((page, idx) =>
                                page === "..." ? (
                                    <button>
                                        <span key={`ellipsis-${idx}`} className="pagination-ellipsis">
                                            ...
                                        </span>
                                    </button>
                                ) : (
                                    <button
                                        key={page}
                                        className={
                                            currentPage === page
                                                ? "pagination-a-active"
                                                : "cursor-pointer"
                                        }
                                        onClick={(e) => {
                                            e.preventDefault();
                                            // If the clicked page is not the current page, change the page
                                            if (currentPage != page) {
                                                handlePageChange(Number(page));
                                            }
                                        }}
                                    >
                                        <span>{page}</span>
                                    </button>
                                )
                            );
                        })()}

                        {/* Next Button */}
                        <button
                            // href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                if (currentPage < totalPages) handlePageChange(currentPage + 1);
                            }}
                            className={currentPage < totalPages ? "cursor-pointer" : "disable_button-blg"}
                        >
                            <span>
                                <img
                                    src={paginationicon}
                                    className="rightpagination-cion"
                                    alt="Next"
                                />
                            </span>
                        </button>
                    </div>}
                </div>

        </>
    );
};

export default PaginationNew2;
